import { sitename } from './strings';

export default (title, includeSitename = true) => {
  if (typeof window !== 'undefined') {
    document.title = title + (includeSitename ? ` | ${sitename}` : '');
  }
};
